export default "__VITE_ASSET__D3ekjNjf__"